import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { changeUserEmail, changeUserPassword } from '../../store/user/actions'
import { logout as logoutAction } from '../../store/auth/actions'

import Card from './Card'
import Title from '../shared/Title'
import ChangeEmailForm from '../form/ChangeEmailForm'
import ChangePasswordForm from '../form/ChangePasswordForm'

import {
  TransparentButton
} from '../shared/styles/Button.style'

class SecurityCard extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    changeUserEmail: PropTypes.func.isRequired,
    changeUserPassword: PropTypes.func.isRequired,
    logout: PropTypes.func,
    translation: PropTypes.func,
    lang: PropTypes.string
  }

  state = {
    securityForm: undefined
  }

  get securityForm () {
    const forms = {
      changePassword: () => (
        <ChangePasswordForm
          lang={this.props.lang}
          translation={this.props.translation}
          onSubmit={({ password }) => this.setState({
            securityForm: undefined
          }, () => this.props.changeUserPassword(this.props.user, password, this.props.translation))}
        />
      ),
      changeEmail: () => (
        <ChangeEmailForm
          lang={this.props.lang}
          translation={this.props.translation}
          emailValue={this.props.user.email}
          onSubmit={({ email }) => this.setState({
            securityForm: undefined
          }, () => this.props.changeUserEmail(this.props.user, email, this.props.translation))}
        />
      )
    }

    return forms[this.state.securityForm]
  }

  render () {
    const { logout, translation } = this.props
    return (
      <Card>
        <Title
          text={translation('securityCard')['security']}
          subtitle={translation('securityCard')['securityWarning']}
        />

        {this.state.securityForm && (
          <div>
            {this.securityForm()}
          </div>
        )}

        {!this.state.securityForm && (
          <div>
            <TransparentButton
              onClick={() => this.setState({ securityForm: 'changePassword' })}
              first
            >
              {translation('securityCard')['changePassword']}
            </TransparentButton>

            <TransparentButton
              onClick={() => this.setState({ securityForm: 'changeEmail' })}
            >
              {translation('securityCard')['changeEmail']}
            </TransparentButton>
            <TransparentButton
              last
              onClick={logout}
            >
              {translation('securityCard')['logoutButton']}
            </TransparentButton>
          </div>
        )}

        {this.state.securityForm && (
          <div>
            <TransparentButton
              onClick={() => this.setState({ securityForm: undefined })}
              first
            >
              {translation('securityCard')['backButton']}
            </TransparentButton>
          </div>
        )}
      </Card>
    )
  }
}

const mapStateToProps = state => ({
  user: state.auth.user
})

const mapDispatchToPros = dispatch =>
  bindActionCreators(
    {
      logout: logoutAction,
      changeUserEmail,
      changeUserPassword
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToPros)(SecurityCard)
